import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { baseButtonStyles } from './LytBaseButton';
const StyledSecondaryButton = styled.button.withConfig({
    shouldForwardProp: (prop) => !['isCompact', 'isIconOnly'].includes(prop),
})`
    ${baseButtonStyles}
    background-color: ${({ theme }) =>
        theme.components.lyt_button.secondary.background.default};
    color: ${({ theme }) => theme.components.lyt_button.secondary.text.default};

    &:not(:disabled):hover {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.secondary.background.hover};
        color: ${({ theme }) =>
            theme.components.lyt_button.secondary.text.hover};
    }

    &:not(:disabled):active {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.secondary.background.pressed};
        color: ${({ theme }) =>
            theme.components.lyt_button.secondary.text.pressed};
    }

    &:focus-visible {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.secondary.background.focus};
        outline: 2px solid
            ${({ theme }) => theme.components.lyt_button.secondary.border.focus};
        outline-offset: 1px;
    }

    &:disabled {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.secondary.background.disabled};
        color: ${({ theme }) =>
            theme.components.lyt_button.secondary.text.disabled}4D;
        /* Target SVG icons inside the button */
        & svg {
            stroke: ${({ theme }) =>
                theme.components.lyt_button.secondary.text.disabled}4D;
        }
        & svg line,
        & svg polyline,
        & svg path,
        & svg rect,
        & svg polygon {
            stroke: ${({ theme }) =>
                theme.components.lyt_button.secondary.text.disabled}4D;
            fill: ${({ theme }) =>
                theme.components.lyt_button.secondary.text.disabled}4D;
        }
    }

    &.lyt-button-selected {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.secondary.background.selected};
        color: ${({ theme }) =>
            theme.components.lyt_button.secondary.text.selected};

        &:hover {
            background-color: ${({ theme }) =>
                theme.components.lyt_button.secondary.background.selected};
            color: ${({ theme }) =>
                theme.components.lyt_button.secondary.text.selected};
        }
    }
`;
const LytSecondaryButton = ({ isCompact = false, ...props }) => {
    return <StyledSecondaryButton isCompact={isCompact} {...props} />;
};
LytSecondaryButton.propTypes = {
    isCompact: PropTypes.bool,
};
export default LytSecondaryButton;
